const actions = {
    GET_NEXT_TRAINING: 'GET_NEXT_TRAINING',
    GET_PREV_TRAINING: 'GET_PREV_TRAINING'
}

export default actions